<template>
  <article
    class="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur transition duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-black/20 sm:p-8"
  >
    <span
      class="pointer-events-none absolute -top-6 -right-2 select-none text-8xl font-black leading-none text-iq-paragraph-color/10"
      >{{ String(num).padStart(2, "0") }}</span
    >
    <div class="flex items-start gap-4">
      <div
        class="grid size-12 place-items-center rounded-xl bg-gradient-to-br from-white/70 to-white/30 text-slate-900 ring-1 ring-inset ring-white/50 transition group-hover:scale-105"
      >
        <slot name="icon">
          <!-- default icon: chat -->
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class="size-6"
          >
            <path d="M7 8h10M7 12h6" />
            <path d="M4 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H9l-4 4V6Z" />
          </svg>
        </slot>
      </div>
      <div>
        <h3 class="text-lg font-semibold text-iq-paragraph-color">{{ title }}</h3>
        <p class="mt-2 text-sm leading-relaxed text-iq-paragraph-color/80">{{ text }}</p>
        <div
          class="mt-5 h-px w-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
        ></div>
        <p v-if="effect" class="mt-3 text-xs text-iq-paragraph-color/70">
          <span
            class="mr-2 inline-block size-1.5 rounded-full bg-emerald-400/80 align-middle"
          ></span
          >{{ effect }}
        </p>
      </div>
    </div>
  </article>
</template>

<script setup>
const { defineProps } = await import("vue");
defineProps({
  num: { type: [Number, String], required: true },
  title: { type: String, required: true },
  text: { type: String, required: true },
  effect: { type: String, default: "" },
});
</script>
